export const environment = {
  production: true,
  appVersionAddon: '',
  webappName: 'Straatbeeld Online',
  api_endpoint: 'https://api.straatbeeld.online/',
  sentry: {
    dsn: 'https://4d7508d29224defc61b5dea37c36ae72@o4507735602298880.ingest.de.sentry.io/4508731207516240'
  }
};
